const isNil = variable => variable === null || variable === undefined;

export { isNil };
//# sourceMappingURL=is-nil.js.map
